import { render, staticRenderFns } from "./bao-cao-doanh-thu.vue?vue&type=template&id=6bc73e46&scoped=true&"
import script from "./bao-cao-doanh-thu.vue?vue&type=script&lang=js&"
export * from "./bao-cao-doanh-thu.vue?vue&type=script&lang=js&"
import style0 from "./bao-cao-doanh-thu.vue?vue&type=style&index=0&id=6bc73e46&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc73e46",
  null
  
)

export default component.exports